import React from 'react';
import {
  AutocompleteDropdown,
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Inscription,
  Label,
  RegularField,
  useFormContext,
  ZipCodeInput,
} from '@common-fe/common-fe';

import { MAX_OPTIONS_COUNT_STATES, useStatesQuery } from '@/modules/core/hooks';
import { CreateOrganizationField, CreateOrganizationForm } from '@/modules/ExpressSetup/ExpressSetupSignUp/hooks/useCreateOrganizationForm';

const Address = () => {
  const { control, formState: { errors } } = useFormContext<CreateOrganizationForm>();
  const { states } = useStatesQuery();

  return (
    <Box
      pad={{ vertical: 'spacing24', horizontal: 'spacing32' }}
      background="canvas"
      round="container1Round"
    >
      <Inscription size="xxlarge" lineHeight="40px">
        Address
      </Inscription>

      <FormFieldsContainer margin={{ top: 'spacing16' }}>
        <FieldWrapper>
          <Label name={CreateOrganizationField.addressLine1} size="large" showRequireIcon>
            Address line 1
          </Label>

          <ControllerWrapper errorText={errors?.[CreateOrganizationField.addressLine1]?.message} defaultSize>
            <Controller
              name={CreateOrganizationField.addressLine1}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="address-line-1"
                  name={CreateOrganizationField.addressLine1}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Address line 1"
                  isError={!!errors?.[CreateOrganizationField.addressLine1]?.message}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateOrganizationField.addressLine2} size="large">
            Address line 2
          </Label>

          <ControllerWrapper errorText={errors?.[CreateOrganizationField.addressLine2]?.message} defaultSize>
            <Controller
              name={CreateOrganizationField.addressLine2}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="address-line-2"
                  name={CreateOrganizationField.addressLine2}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Address line 2"
                  isError={!!errors?.[CreateOrganizationField.addressLine2]?.message}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateOrganizationField.city} size="large" showRequireIcon>
            City
          </Label>

          <ControllerWrapper errorText={errors?.[CreateOrganizationField.city]?.message} defaultSize>
            <Controller
              name={CreateOrganizationField.city}
              control={control}
              render={({ field }) => (
                <RegularField
                  testId="city"
                  name={CreateOrganizationField.city}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Enter city"
                  isError={!!errors?.[CreateOrganizationField.city]?.message}
                  isLarge
                  editMode
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateOrganizationField.state} size="large" showRequireIcon>
            State
          </Label>

          <ControllerWrapper defaultSize>
            <Controller
              name={CreateOrganizationField.state}
              control={control}
              render={({ field }) => (
                <AutocompleteDropdown
                  testId="state"
                  name={CreateOrganizationField.state}
                  errorText={errors?.[CreateOrganizationField.state]?.message}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Select state"
                  options={states}
                  maxOptionsCount={MAX_OPTIONS_COUNT_STATES}
                  isLarge
                />
              )}
            />
          </ControllerWrapper>

        </FieldWrapper>

        <FieldWrapper>
          <Label name={CreateOrganizationField.zipCode} size="large" showRequireIcon>
            ZIP code
          </Label>

          <ControllerWrapper defaultSize>
            <Controller
              name={CreateOrganizationField.zipCode}
              control={control}
              render={({ field }) => (
                <ZipCodeInput
                  name={CreateOrganizationField.zipCode}
                  errorText={errors?.[CreateOrganizationField.zipCode]?.message}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="Enter ZIP code"
                  isLarge
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default Address;
